let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71qoR")).then(() => parcelRequire('2HdNw'));